import { type ListChatSource, mapShipmentToShipperContact } from 'core/chat/domain/Chat'
import { formatChatSubject } from 'core/chat/presenters/chatPresenter'

import { type AgnosticShipment } from '../domain/AgnosticShipment'
import { type Shipment } from '../domain/Shipment'
import { getInviteTokenFromShipmentUrl } from '../domain/shipmentListChat'

export function mapShipmentToListChatCreate(shipment: Shipment) {
  return {
    shipper: mapShipmentToShipperContact(shipment),
    subject: formatChatSubject({
      shipmentId: shipment.shipperGuideId,
      carrierName: shipment.carrier.name,
    }),
  }
}

export function mapAgnosticShipmentToChatSource(shipment: AgnosticShipment): ListChatSource {
  if (!shipment.bookedRateUuid) {
    throw new Error('Could not find a booked rate for the shipment')
  }

  return {
    entityIdentifier: shipment.bookedRateUuid,
    inviteToken: getInviteTokenFromShipmentUrl(shipment.shipmentURL),
    shipper: {
      name: shipment.shipper.name || shipment.shipper.companyName,
      email: shipment.shipper.email,
    },
    subject: formatChatSubject({
      shipmentId: shipment.shipperGuideId,
      carrierName: shipment.shipper.companyName,
    }),
    subtitle: shipment.shipper.companyName,
  }
}
